export default __webpack_public_path__ + "static/media/59.a8de316f.jpeg";